import Swiper, {Autoplay, EffectFade, Pagination} from "swiper";
import GET_ARTICLES from "../class/getArticles";

const [d] = [document];

const domReady = TPL => {
  const mainvisual = new Swiper('.mainvisual [data-plugin="slider"]',{
    modules: [Autoplay, EffectFade, Pagination],
    loop: true,
    effect: 'fade',
    speed: 1200,
    fadeEffect: {
      crossFade: true, // クロスフェードを有効にする（フェードモードの場合 true 推奨）
    },
    autoplay:{
      delay: 4500,
      disableOnInteraction: false,
      waitForTransition: false
    },
    pagination: {
      el: ".mainvisual-slider__pager",
      clickable: true,
    },
  });

  const news_block = new GET_ARTICLES('.block-news__list[data-plugin="getArticles"]');
  news_block.makeItem = (item,content) => `
  <li class="block-${content}-item">
    <a href="${item.href}" class="block-${content}-item__link">
      <div class="block-${content}-item__body">
        <div class="date-cate">
          <span class="date">${item.date}</span>
          <span class="cate">${item.category.name}</span>
        </div>
        <h4 class="title ${item.is_new? 'is-new':''}">${item.title.str_truncate(24)}</h4>
      </div>
    </a>
  </li>`;
  // news_block.makeItem = (item) => console.log(item);
  news_block.render();

  const works_block = new GET_ARTICLES('.block-works__list[data-plugin="getArticles"]');
  works_block.maketag = (tags) => tags.map(tag => `<span class="tag">${tag}</span>`).join('');
  works_block.makeItem = (item,content) => `
  <li class="block-works-item">
    <a href="${item.href}" class="block-works-item__link">
      <figure class="block-works-item__thumb">
        <img src="${item.thumb}" alt="${item.title}" width="100%" loading="lazy" class="block-works-item__thumb-img">
      </figure>
      <div class="block-works-item__body">
        <h5 class="title">${item.title}</h5>
        ${item.keywords? '<div class="tags">'+ works_block.maketag(item.keywords) + '</div>': ''}
      </div>
      <!-- /.block-works-item__body -->
    </a>
    <!-- /.block-works-item__link -->
  </li>`;
  // works_block.makeItem = (item) => console.log(item);
  works_block.render();

  const uservoice_block = new GET_ARTICLES('.block-uservoice__list[data-plugin="getArticles"]');
  uservoice_block.maketag = (tags) => tags.map(tag => `<span class="tag">${tag}</span>`).join('');
  uservoice_block.makeItem = (item,content) => `
  <li class="block-uservoice-item">
    <a href="${item.href}" class="block-uservoice-item__link">
      <figure class="block-uservoice-item__thumb">
        <img src="${item.thumb}" alt="${item.title}" width="100%" loading="lazy" class="block-uservoice-item__thumb-img">
      </figure>
      <div class="block-uservoice-item__body">
        <div class="block-uservoice-item__body-inner">
          <h5 class="title">${item.title}</h5>
          ${item.keywords? '<div class="tags">'+ uservoice_block.maketag(item.keywords) + '</div>': ''}
        </div>
      </div>
      <!-- /.block-uservoice-item__body -->
    </a>
    <!-- /.block-uservoice-item__link -->
  </li>`;
  // uservoice_block.makeItem = (item) => console.log(item);
  uservoice_block.render();
  
};

const jqInit = () => false;

export default function HOME () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  
  $(() => jqInit());
}